var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel-slide'),_c('br'),_c('charcoal-products'),_c('team-carousel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }